package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.DrawPoint
import fr.manyverse.app.domain.model.WhiteboardAction
import fr.manyverse.app.domain.model.WhiteboardColor
import fr.manyverse.app.domain.repository.WhiteboardRepository

/**
 * Use case for drawing a stroke on the whiteboard.
 * Broadcasts the stroke action to all participants.
 */
class DrawOnWhiteboardUseCase(
    private val whiteboardRepository: WhiteboardRepository
) {
    /**
     * Draws a stroke on the whiteboard.
     *
     * @param tableId The game table ID
     * @param whiteboardId The whiteboard ID
     * @param points List of points making up the stroke
     * @param color The stroke color
     * @param strokeWidth The stroke width
     * @param performedBy The user ID who drew the stroke
     * @return Result indicating success or failure
     */
    suspend operator fun invoke(
        tableId: String,
        whiteboardId: String,
        points: List<DrawPoint>,
        color: WhiteboardColor,
        strokeWidth: Float,
        performedBy: String
    ): Result<Unit> {
        if (points.isEmpty()) {
            return Result.success(Unit)
        }

        val action = WhiteboardAction.Stroke(
            points = points,
            color = color,
            strokeWidth = strokeWidth
        )

        return whiteboardRepository.broadcastAction(
            tableId = tableId,
            whiteboardId = whiteboardId,
            action = action,
            performedBy = performedBy
        )
    }
}
